import { render, staticRenderFns } from "./RespondentsList.vue?vue&type=template&id=4ef635e4&scoped=true&"
import script from "./RespondentsList.vue?vue&type=script&lang=ts&"
export * from "./RespondentsList.vue?vue&type=script&lang=ts&"
import style0 from "./RespondentsList.vue?vue&type=style&index=0&id=4ef635e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef635e4",
  null
  
)

export default component.exports